// Documento/página principal
const $root = $(':root');

// Arquivo de configuração do tema
let confTheme = {};

// Verifica se está no modo de pré-visualização
const previewMode = $root.data('preview') == '1';

let sectionHomeCur;

// Verifica se está no modo de pré-visualização
if (previewMode) {
  // Evento geral disparado ao carregar as configurações
  const confEvtDefault = 'loaded-confs';

  // Recebe uma mensagem com a configuração do tema
  function receiveConfs(evt) {
    //console.log(evt);
    // Domínios confiáveis (Domínio do editor)
    const trustedSenders = [
      'http://localhost',
      'http://192.168.15.50',
      'http://192.168.15.14',
      'https://loja.com.br',
      'https://app.loja.com.br',
      'https://loja.io',
    ];
    // Verifica o remetente
    /* if (trustedSenders.indexOf(evt.origin) !== -1) { */
    if (typeof evt.data === 'string') {
      const receivedConfs = JSON.parse(evt.data);
      const evtTriggered = receivedConfs.evt ? receivedConfs.evt : confEvtDefault;
      console.log(evtTriggered);
      if (evtTriggered) {
        // Seções dinâmicas home loja
        if (
          receivedConfs.section != '' &&
          (evtTriggered === 'shstore-add' || evtTriggered === 'shstore-upd' || evtTriggered === 'shstore-rem')
        ) {
          confTheme = JSON.parse(receivedConfs.settings);
          sectionHomeCur = receivedConfs.section;
          $root.trigger(evtTriggered);
        }
        // Foca em uma seção
        else if (evtTriggered === 'sec-focus') {
          lpLpsSecFocus(receivedConfs.section);
        }
        // Eventos de alterações gerais
        else {
          confTheme = JSON.parse(receivedConfs.settings);
          $root.trigger(evtTriggered);
        }
      }
    }
    /* }
    // Remetente não autorizado.
    else {
      console.log('Origin: ' + evt.origin);
      throw new Error('Você não possui permissão para executar esta operação.');
    } */
  }
  if (window.addEventListener) {
    window.addEventListener('message', receiveConfs, false);
  } else {
    window.attachEvent('onmessage', receiveConfs);
  }

  // Carrega as configurações armazenadas localmente
  /* $(window).on('load', function () {
    if (localStorage.getItem('conf_theme_' + baseTheme + '_' + baseTemplate + '_' + baseLanding)) {
      loadLocalConfs();
      $root.trigger(confEvtDefault);
    }
  }); */
  /* function loadLocalConfs() {
    const confThemeStore = localStorage.getItem('conf_theme_' + baseTheme + '_' + baseTemplate + '_' + baseLanding);
    if (confThemeStore) {
      confTheme = JSON.parse(confThemeStore);
    }
  } */

  // Desabilita os links e botões da página
  function disableLinks() {
    $('body').on('click', 'a, button', function (evt) {
      evt.preventDefault();
    });
  }
  disableLinks();

  // Desabilida o clique do botão direito do mouse
  function disableRightClick() {
    $(window).on('contextmenu', function (ev) {
      ev.preventDefault();
    });
  }
  disableRightClick();

  // Foca em uma seção
  function lpLpsSecFocus(section) {
    const $section = $(section);
    if ($section.length > 0) {
      let offset = 0;
      if ($('#header').length > 0 && $('#header').css('position') === 'fixed') {
        offset += $('#header').outerHeight();
      }
      if ($('#menu').length > 0 && $('#menu').css('position') === 'fixed') {
        offset += $('#menu').outerHeight();
      }
      smoothScroll($section, offset);
    }
  }

  // Configurações do MarkedJS
  if (typeof marked !== 'undefined') {
    marked.setOptions({
      breaks: true,
    });
  }

  // Altera a ordem das seções
  function changeSectionsOrder() {
    const orders = confTheme['sections-order'];
    if (orders && Object.keys(orders).length > 0) {
      Object.keys(orders).forEach((section) => {
        const $section = $('#' + section);
        const order = parseInt(confTheme['sections-order'][section]);
        if ($section.length > 0) {
          $section[0].style.setProperty('--order', order);
        }
      });
    }
  }
  $root.on(confEvtDefault + ' lp-evt-sections-order', changeSectionsOrder);
}

// Recarrega os carrosséis ao redimencionar a tela
$(window).on(
  'resize',
  debounce(function () {
    $('.carousel').each(function () {
      const $slider = $(this);
      if ($slider[0].slick !== undefined) {
        setTimeout(() => {
          $slider.slick('resize');
        }, 100);
        setTimeout(() => {
          $slider.slick('resize');
        }, 500);
      }
    });
  }, 100),
);
